import { Link } from "react-router-dom";
import { Mountain } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-white">
      <div className="mx-auto max-w-7xl px-6 py-14 lg:px-8">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                <Mountain className="h-5 w-5" strokeWidth={2.5} />
              </span>
              <span className="font-heading text-xl font-extrabold tracking-tight text-slate-900">
                Peak<span className="text-primary">Points</span>
              </span>
            </div>
            <p className="mt-3 max-w-xs font-body text-sm leading-relaxed text-slate-500">
              Know what your points are actually worth. Simple calculators and
              guides to help you get more value from credit-card and travel rewards.
            </p>
          </div>

          <div>
            <p className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
              Explore
            </p>
            <ul className="mt-4 space-y-2 font-body text-sm">
              <li><Link to="/" className="text-slate-600 hover:text-primary">Points Calculator</Link></li>
              <li><Link to="/guides" className="text-slate-600 hover:text-primary">Points Guides</Link></li>
              <li><Link to="/about" className="text-slate-600 hover:text-primary">About</Link></li>
              <li><Link to="/contact" className="text-slate-600 hover:text-primary">Contact</Link></li>
            </ul>
          </div>

          <div>
            <p className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
              Legal
            </p>
            <ul className="mt-4 space-y-2 font-body text-sm">
              <li><Link to="/terms" className="text-slate-600 hover:text-primary">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-slate-600 hover:text-primary">Privacy Policy</Link></li>
              <li><Link to="/sms-terms" className="text-slate-600 hover:text-primary">SMS Terms</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-border pt-6 font-body text-sm text-slate-400 md:flex-row md:items-center">
          <p>© {new Date().getFullYear()} Peak Points. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <p>Estimates only — not financial advice.</p>
            <Link to="/login" data-testid="footer-owner-login" className="font-medium text-slate-500 hover:text-primary">Owner Login</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
